<template>
  <section class="section-y">
    <div class="max-w-(--breakpoint-xl) mx-auto px-4">
      <div class="rounded-3xl bg-teal-900 p-6 md:py-14 md:px-12">
        <p
          v-if="content?.eyebrow"
          class="text-sm font-bold uppercase tracking-wider text-success mb-4"
        >
          {{ content.eyebrow }}
        </p>

        <h3
          v-if="content?.title"
          class="section-title text-white max-w-[640px] mb-7 md:mb-8"
        >
          {{ content.title }}
        </h3>

        <ul class="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-6 md:gap-x-12">
          <li
            v-for="(item, index) in content?.items"
            :key="item?.id ?? index"
            class="flex gap-3"
          >
            <img
              v-if="iconUrl"
              :src="iconUrl"
              class="size-2.5 md:size-3.5 shrink-0 mt-1"
              alt=""
              aria-hidden="true"
            />
            <IconCheck
              v-else
              class="size-2.5 md:size-3.5 shrink-0 mt-1 text-lime-200"
              aria-hidden="true"
            />

            <div>
              <h4 class="text-base font-semibold text-white">
                {{ item?.title }}
              </h4>
              <p
                v-if="item?.description"
                class="text-sm text-teal-100 leading-snug"
              >
                {{ item.description }}
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import IconCheck from '~/assets/icons/check-generic.svg?component'
import { strapiImageGetters } from '~/utils/strapiImageGetters'

interface FeatureListItem {
  id?: number | string
  title?: string
  description?: string
}

interface FeatureListContent {
  eyebrow?: string
  title?: string
  icon?: any
  items?: FeatureListItem[]
}

const { content = {} } = defineProps<{ content?: FeatureListContent }>()

/**
 * The check icon is authored as an SVG upload in Strapi and rendered as-is
 * (it carries its own colour). Falls back to the bundled check icon when the
 * CMS block has no SVG icon uploaded.
 */
const iconUrl = computed(() => {
  const image = content?.icon
  const isSvg =
    image?.mime === 'image/svg+xml' || /\.svg(?:[?#]|$)/i.test(image?.url ?? '')
  const url = isSvg ? strapiImageGetters.getImageUrl(image) : ''
  return /^https?:\/\//.test(url) ? url : ''
})
</script>
